module.exports = __webpack_public_path__ + "static/media/checkmark.07980066.svg";